import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleXmark,
} from '@fortawesome/pro-regular-svg-icons';
import styles from '../PlayerPortalsOnSiteRegistrationAdminPanel.module.scss';

export const PolicyItem = ({
  text,
  accepted,
}: {
  text: string;
  accepted?: boolean;
}) => (
  <div className={styles.policyItem}>
    <p className={styles.policyText}>{text}</p>
    <FontAwesomeIcon
      icon={accepted ? faCircleCheck : faCircleXmark}
      className={`${styles.policyIcon} ${
        accepted ? styles.checkmark : styles.xmark
      }`}
    />
  </div>
);

export default PolicyItem;
